<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" :val="headerTitle" :type="'empty'"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <section class="hr">
          <div class="guideMsg" v-if="businessHourYn != 'Y'">
            <p class="txtL">
              지금은 고객센터 운영시간이 아닙니다.
              <br />
              상담신청을 남겨주시면
              <br />
              웰몰 전문상담원이 상담해 드립니다.
            </p>
            <p class="txt">고객센터 운영시간은 평일 오전 9시~오후 6시 입니다.</p>
          </div>
          <div class="guideMsg" v-else>
            <p class="txtL">
              전문 상담원 통한 상담을 원하시면
              <br />
              아래의 정보를 입력 후 상담예약을
              <br />
              남겨주세요.
            </p>
          </div>

          <div class="formArea">
            <span class="label">
              이름
              <span class="required"><span class="blind">필수</span></span>
            </span>
            <input type="text" id="ipt4" class="ipt" title="이름 입력" value="" v-model="userName" />

            <span class="label">
              휴대폰번호
              <span class="required"><span class="blind">필수</span></span>
            </span>
            <input
              type="tel"
              id="phone_2"
              class="ipt"
              title="휴대폰 번호 입력"
              placeholder="' - ' 없이 입력해주세요."
              value=""
              v-model="cellNum"
              v-onlyNum
            />

            <!-- 약관 (s) -->
            <div class="termsWrap">
              <div class="inner">
                <ul class="iptGroup">
                  <li>
                    <div class="block">
                      <input type="checkbox" class="ipt" name="terms1" id="terms1_3" v-model="terms" />
                      <label for="terms1_3">
                        <span>[필수]</span>
                        개인정보수집 및 이용약관 동의
                      </label>
                      <button type="button" class="links arrow" @click="popupOpen"><span class="blind">상세약관 전체보기</span></button>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <!-- 약관 (e) -->
          </div>

          <div class="btnArea sticky">
            <button type="button" class="btn_p" @click="reservationAdvice" :disabled="regButtonShow">상담예약</button>
          </div>
        </section>
        <MessagePop v-if="messagePopFlag" @close="close">
          <p v-html="msg"></p>
        </MessagePop>
        <CallServiceTermPop v-if="CallServiceTermPopFlag" @close="close" @agree="agree"></CallServiceTermPop>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import ApiService from '@/common/api.service';
import MessagePop from '@/components/popup/MessagePop';
import { RESERVATION_ADVICE, INPUT_INFO_CHECK, TERM_AGREE_CHECK } from '@/store/message.type.js';
import CallServiceTermPop from '@/views/app/comm/CallServiceTermPop';
import JwtService from '@/common/jwt.service';
import { isEmpty } from '@/common/common.function';

export default {
  name: 'CallService',
  components: {
    MessagePop,
    CallServiceTermPop,
  },
  mounted() {
    this.selectCommonBusinesshours();
    if (this.userInfo != null) {
      this.userName = this.userInfo.userName;
      this.cellNum = this.userInfo.mobile;
    }
  },
  data: function() {
    return {
      headerTitle: '상담예약',
      userInfo: JwtService.getUserInfo(),
      cellNum: null,
      userName: null,
      terms: null,

      messagePopFlag: null,
      success: false,
      msg: null,
      CallServiceTermPopFlag: null,

      businessHourYn: 'Y', // Y -> 영업일, N -> 영업 외 시간

      regButtonShow: true,
    };
  },
  watch: {
    userName() {
      this.checkInput();
    },
    cellNum() {
      this.checkInput();
    },
    terms() {
      this.checkInput();
    },
  },
  methods: {
    selectCommonBusinesshours() {
      ApiService.service('GET', '/common/businesshours')
        .then(({ data }) => {
          if (data.isSucceed) {
            this.businessHourYn = data.result.businessHourYn;
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
    reservationAdvice: function() {
      if (!this.terms) {
        this.msg = TERM_AGREE_CHECK;
        this.messagePopFlag = true;
        return false;
      }

      if (this.cellNum == null || this.cellNum == '') {
        this.msg = INPUT_INFO_CHECK;
        this.messagePopFlag = true;
        return false;
      }

      if (this.userName == null || this.userName == '') {
        this.msg = INPUT_INFO_CHECK;
        this.messagePopFlag = true;
        return false;
      }

      let param = new Object();
      let request = new Object();

      request.cellNum = this.cellNum;
      request.userName = this.userName;
      param.request = request;
      param.serviceType = 'app';

      ApiService.service('POST', '/user/advice', param)
        .then(({ data }) => {
          if (data.isSucceed) {
            this.msg = RESERVATION_ADVICE;
            this.messagePopFlag = true;
            this.success = true;
          } else if (data.error != '') {
            this.msg = data.error;
            this.messagePopFlag = true;
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
    close: function() {
      this.messagePopFlag = false;
      this.CallServiceTermPopFlag = false;
      if (this.success) this.$router.go(-1);
    },
    agree: function() {
      this.terms = true;
      this.CallServiceTermPopFlag = false;
    },
    popupOpen: function() {
      this.CallServiceTermPopFlag = true;
    },
    checkInput() {
      if (!isEmpty(this.userName) && !isEmpty(this.cellNum) && this.terms === true) {
        this.regButtonShow = false;
      } else {
        this.regButtonShow = true;
      }
    },
  },
};
</script>
